// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"wa_a bhn_b bhn_we"};